import { createContext } from 'react';
var defaultValue = {
    scrollView: undefined,
};
export var ScrollViewContext = createContext(defaultValue);
//# sourceMappingURL=context.js.map